import {Component} from '@angular/core';

@Component({
    templateUrl: './EfsMainReportComponent.html',
    standalone: false
})
export class EfsMainReportComponent {
}
